import { render } from "./index.vue?vue&type=template&id=54e5d203&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-54e5d203"

export default script